import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import FullPagePopupLayout from './Popups/FullPagePopupLayout'
import { messageModalState } from '../store/Feedback'

const MessageModal = () => {
  const [modelState, setModelState] = useRecoilState(messageModalState)
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    if (modelState?.message) {
      setOpen(true)
    }
  }, [modelState])

  const clearModal = () => {
    setOpen(false)
    setModelState(null)
  }

  const handleClose = () => {
    const callback = modelState?.callback
    clearModal()
    callback?.()
  }

  const handleDismiss = () => {
    clearModal()
  }

  const handleKycRedirect = () => {
    setOpen(false)
    navigate('dashboard/start-kyc')
  }

  if (!modelState?.message) {
    return null
  }

  const isKycPrompt = modelState.severity === 'info' && modelState.linkMessage
  const severity = modelState.severity || 'notice'
  const title = isKycPrompt
    ? 'Complete your KYC to proceed'
    : modelState.title || (severity === 'error' ? 'Something went wrong' : 'Information')
  const message = isKycPrompt
    ? typeof modelState.linkMessage === 'string' && modelState.linkMessage
      ? modelState.linkMessage
      : 'Your KYC verification is pending. Please contact our support team at +91-8050034800 to complete the process.'
    : modelState.message
  const supportingMessage = !isKycPrompt ? modelState.additionaInfo : null
  const canCloseFromOverlay = severity !== 'error' && !modelState.confirmation

  return (
    <FullPagePopupLayout
      isOpen={open}
      onClose={canCloseFromOverlay ? handleClose : undefined}
      severity={severity}
      title={title}
      message={message}
      bodyClassName={supportingMessage ? undefined : 'hidden'}
      actionsClassName={isKycPrompt ? undefined : 'fabits-global-popup-actions-single'}
      actions={
        isKycPrompt ? (
          <>
            <button
              type='button'
              className='fabits-global-popup-button fabits-global-popup-button-secondary'
              onClick={handleDismiss}
            >
              Remind me later
            </button>
            <button
              type='button'
              className='fabits-global-popup-button fabits-global-popup-button-primary'
              onClick={handleKycRedirect}
            >
              Complete KYC
            </button>
          </>
        ) : (
          <button
            type='button'
            className='fabits-global-popup-button fabits-global-popup-button-primary'
            onClick={severity === 'error' ? handleDismiss : handleClose}
          >
            Close
          </button>
        )
      }
    >
      {supportingMessage && <p className='fabits-global-popup-supporting'>{supportingMessage}</p>}
    </FullPagePopupLayout>
  )
}

export default MessageModal
